import React, { useEffect, useState } from "react"
import { styles, uploadAllowances, downloadAllowances, uploadAgeTable } from "../util"

import { ButtonGroup } from "@mui/material"
import { FileUploader } from "../../../../../../legacyComponents/componentsV2"
import { useContext } from "react"
import { UserContext } from "../../../../../../context/UserContext"
export default function Component(props) {
	const { getEmployer, getEmployerPlan } = useContext(UserContext)
	const employer = getEmployer()
	const employerPlan = getEmployerPlan(props.employerPlanId)
	const { formik,setFile,setData } = props
	const [values,setValues] = useState(null);
	const [maxBenefit,setMaxBenefit] = useState({
		AGE:false,
		FAMILY_AGE:false
	});
	const [insurance,setInsurance] = useState(false) // this is default false, if this compoennt is used in insurance calculator then it will be true 
	const [benefitType,setBenefitType] = useState("AGE");
	useEffect(()=>{
		if(formik) {
			setValues(formik.values);
			if(formik?.values){
				setMaxBenefit(formik?.values?.maxBenefit);
				if(formik?.values?.maxBenefit?.AGE){
					setBenefitType("AGE")
				} else if(formik?.values?.maxBenefit?.FAMILY_AGE ){
					setBenefitType("FAMILY_AGE")	
				}
			}
		} else {
			setMaxBenefit({ AGE: true });
			setBenefitType("AGE");
			setInsurance(true);
		}
	}, [formik]);

	const uploadBtnHandler = () =>{
		document.getElementById("file-uploader")?.click()
	}

	const fileUploadHandler = async({file}) =>{
		formik.setTouched({});
		formik.setFieldValue("age_qualify", "Yes")
		if(!insurance) {
		 	await uploadAllowances(props, file, setData, employer)
		} else {
			if(setFile != undefined){
				await uploadAgeTable(props, file,setData)
				setFile(file);
			}
		}
	}
	return (
		<ButtonGroup sx={styles.allowanceButtons}>
			<FileUploader accept={["csv", "excel"]} handleChange={fileUploadHandler} />

			<button type="button" onClick={() => downloadAllowances(employerPlan, values, benefitType)}>
				Download Allowances
			</button>

			<button type="button" onClick={() => uploadBtnHandler()}>
				Upload Allowances
			</button>
		</ButtonGroup>
	)
}
